/**
 * Single source of truth for search / SEO / preview crawler User-Agents.
 * Used by: server.ts (SSR human gate), HumanVerifyService / guard.
 * index.html does not duplicate this list — crawlers get cs_human_verified cookie from server.
 */
export const SEARCH_CRAWLER_UA_TOKENS: readonly string[] = [
  // Google
  'Googlebot',
  'Google-InspectionTool',
  'AdsBot-Google',
  'Storebot-Google',
  'APIs-Google',
  'Mediapartners-Google',
  'Google-CloudVertexBot',
  'GoogleOther',
  'Chrome-Lighthouse',
  'Google-Read-Aloud',
  'FeedFetcher-Google',
  // Bing / other search
  'bingbot',
  'BingPreview',
  'Slurp', // Yahoo
  'DuckDuckBot',
  'Baiduspider',
  'YandexBot',
  'Applebot',
  // AI search / assistants
  'OAI-SearchBot',
  'ChatGPT-User',
  'PerplexityBot',
  'Perplexity-User',
  'Claude-SearchBot',
  'Claude-User',
  // Social / preview
  'facebookexternalhit',
  'Facebot',
  'Twitterbot',
  'LinkedInBot',
  'Pinterestbot',
  'Slackbot',
  'Discordbot',
  'WhatsApp',
  'redditbot',
  'Quora Link Preview',
  // SEO / audit / archive
  'SemrushBot',
  'AhrefsBot',
  'AhrefsSiteAudit',
  'SiteAuditBot',
  'DotBot',
  'MJ12bot',
  'PetalBot',
  'archive.org_bot',
];

/** Returns true when UA looks like an allowed search/SEO crawler. */
export function isSearchCrawlerUserAgent(userAgent: string | null | undefined): boolean {
  if (!userAgent?.trim()) {
    return false;
  }
  return SEARCH_CRAWLER_UA_TOKENS.some((token) => userAgent.includes(token));
}
